import React from 'react';
import { Eraser, Hand } from 'lucide-react';
import { TYPES_ZONE } from '../../utils/merchandising';

export const COULEURS_FAMILLE = ['bg-sky-500', 'bg-rose-500', 'bg-amber-500', 'bg-emerald-500', 'bg-teal-500'];
export const COULEURS_ZONE = { promo: 'bg-red-600', impulsion: 'bg-pink-500', service: 'bg-slate-500' };

export const couleurItem = (value, fams) => {
  if (!value) return 'bg-ink-800';
  if (COULEURS_ZONE[value]) return COULEURS_ZONE[value];
  const i = fams.findIndex(f => f.id === value);
  return i >= 0 ? COULEURS_FAMILLE[i % COULEURS_FAMILLE.length] : 'bg-ink-700';
};

export const libelleItem = (value, fams) => {
  if (!value) return 'Vide';
  const z = TYPES_ZONE.find(t => t.id === value);
  if (z) return `${z.emoji} ${z.nom}`;
  return fams.find(f => f.id === value)?.nom || value;
};

/** Palette : cliquer pour choisir le « pinceau », ou glisser-déposer sur la grille. */
export const PaletteMerch = ({ fams, zones = [], selection, onSelect, testPrefix }) => {
  const items = [
    ...fams.map(f => ({ value: f.id, label: f.nom, sub: `${Math.round(f.part_demande * 100)} % demande · coef ${f.coefficient}` })),
    ...zones.map(z => ({ value: z.id, label: `${z.emoji} ${z.nom}`, sub: z.description })),
  ];
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-palette`}>
      <p className="text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1"><Hand className="w-3 h-3" /> Palette — cliquez puis peignez, ou glissez-déposez</p>
      <div className="flex flex-wrap gap-2">
        {items.map(it => (
          <button
            key={it.value}
            type="button"
            draggable
            onDragStart={e => { e.dataTransfer.setData('text/plain', it.value); e.dataTransfer.effectAllowed = 'copy'; }}
            onClick={() => onSelect(selection === it.value ? null : it.value)}
            title={it.sub}
            className={`px-2.5 py-1.5 rounded text-xs font-bold text-white flex items-center gap-1.5 transition-transform hover:-translate-y-0.5 ${couleurItem(it.value, fams)} ${selection === it.value ? 'ring-2 ring-white ring-offset-2 ring-offset-ink-900' : 'opacity-90'}`}
            data-testid={`${testPrefix}-palette-${it.value}`}
          >
            {it.label}
          </button>
        ))}
        <button
          type="button"
          onClick={() => onSelect(selection === '__vide' ? null : '__vide')}
          className={`px-2.5 py-1.5 rounded text-xs font-bold flex items-center gap-1.5 border border-ink-600 text-slate-300 hover:bg-ink-800 ${selection === '__vide' ? 'ring-2 ring-white ring-offset-2 ring-offset-ink-900' : ''}`}
          data-testid={`${testPrefix}-palette-vider`}
        >
          <Eraser className="w-3.5 h-3.5" /> Gomme
        </button>
      </div>
    </div>
  );
};
